import { render } from "./coach-request-count.vue?vue&type=template&id=7acbb4ef"
import script from "./coach-request-count.vue?vue&type=script&lang=js"
export * from "./coach-request-count.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__